// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__8DdMQ","heading":"style_heading__tR_re","text":"style_text__wMPei"};